/**
 * 同售积分消耗测算（端内"预计消耗积分"展示用）
 *
 * 命中规则与服务端 SaleShelfPointsService.matchConsumePoints 一致：
 * 取「起算价 <= 售价」的档位中起算价最大的那一档，返回该档 points（分）
 * 阶梯来源：商户渠道绑定表 sale_config，形如 [{price:100, points:10}, ...]
 * 测算只服务于展示，提交链路不校验、不落库，实际消耗以成交发货/收款扣减为准
 */

/**拉取商户启用渠道的积分阶梯，回调出 { [channel_id]: [{price, points}] }；未配置阶梯的渠道服务端不下发*/
export function fetchPointsConfig(vm, callback) {
	vm.request({
		url: '/sale/product/points/config',
		success: data => {
			var map = {};
			(data || []).forEach(item => {
				map[item.channel_id] = item.tiers || [];
			});
			if (callback) callback(map);
		}
	});
}

/**取命中档位：起算价 <= 售价 中起算价最大的那一档，售价低于最低档起算价时返回 null*/
export function matchConsumeTier(tiers, sale_price) {
	if (!tiers || !tiers.length) return null;
	var price = parseFloat(sale_price);
	if (!(price > 0)) return null;
	var matched = null;
	for (var i = 0; i < tiers.length; i++) {
		var start = parseFloat(tiers[i].price);
		if (isNaN(start) || start > price) continue;
		if (!matched || start > parseFloat(matched.price)) matched = tiers[i];
	}
	return matched;
}

/**
 * 测算本次上架预计消耗的同售积分
 * @param config_map 积分阶梯集合（fetchPointsConfig 回调所得）
 * @param channel_id 渠道ID
 * @param sale_price 售价
 * @returns {Number|null} 渠道无阶梯、未命中档位或售价非法时返回 null（该渠道该价不消耗积分，端内不展示金额）
 */
export function calcConsumePoints(config_map, channel_id, sale_price) {
	var tiers = config_map ? config_map[channel_id] : null;
	var tier = matchConsumeTier(tiers, sale_price);
	if (!tier) return null;
	var points = parseInt(tier.points);
	return isNaN(points) || points < 0 ? 0 : points;
}
